import Banner from "../components/banner";
import Content from "../components/content";
import Footer from "../components/footer";
import Navbar from "../components/navbar";

function HomePage() {
  return (
    <>
      <div className="max-w-screen-xl  mx-auto pt-20 flex-col bg-fixed">
        <Navbar>
          <Banner />
          <Content />
          <Footer />
        </Navbar>
      </div>
    </>
  );
}
export default HomePage;
